import React from 'react';
import { Col } from 'reactstrap';

export const MostTradedStock = ({ mostTradedStock }) => {
    const handleNavigateToStock = (e) => {
        e.preventDefault();
        
        window.location.href = `/ticker/${mostTradedStock.Exchange}/${mostTradedStock.Ticker}`;
    };

    if (!mostTradedStock) return null;
    return (
        <Col md={4} className="flex-fill text-center mb-4 mb-md-0">
            <div className="ad_home_summary_bottom_headline fw-bold">{mostTradedStock.Name}</div>
            <a className="ad_white_link" href="#">
                <div className="d-flex justify-content-center mt-1">
                    <div className="text-center">
                        <div className="ad_home_summary_bottom_stock_text_adjust ad_home_summary_bottom_stock_subtitle" onClick={handleNavigateToStock}>{mostTradedStock.Ticker} - {mostTradedStock.Exchange}</div>
                    </div>
                </div>
            </a>
        </Col>
    );
}



// WEBPACK FOOTER //
// ./src/c/MostTradedStock.js